module.exports = __webpack_public_path__ + "img/主效果图.jpg.c03a8e51.webp";